// components/ui/ScrollProgress.jsx
"use client";
import { useEffect, useState } from "react";

export default function ScrollProgress({ className }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.body.scrollHeight - window.innerHeight;
            const scrolled = Math.min((scrollTop / docHeight) * 100, 100);
            setProgress(scrolled);
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div
            className={className}
            style={{
                transform: `scaleX(${progress / 100})`,
                transformOrigin: "left",
            }}
        />
    );
}
